import { TFunction } from 'i18next'

export const getCommercialTermChoiceTranslation =
  (t: TFunction<string>) =>
  (key: string, value: string | number | null | undefined): string | undefined =>
    t(`commercialTerms:${key}#choices#${value}`, { keySeparator: '#' })

export const translateOfferingQuestionTitle = (t: TFunction) => (key: string) => t(`offerSelections:${key}.title`)
